import qs from "qs";
import { ApiClientBase } from "api/ApiClientBase";

class RegionSummaryApiClient extends ApiClientBase {
    buildRegionSummary(regionId, format) {
        return this.post(
            `api/v1/region/summary/${regionId}/build?${qs.stringify({ format })}`,
        ).then((x) => x.data);
    }
}

// eslint-disable-next-line import/no-anonymous-default-export
export default new RegionSummaryApiClient();
